export default "<footer class=\"footer\"></footer>"